var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "typeahead-".concat(_vm.id),
      "role": "combobox",
      "aria-haspopup": "listbox",
      "aria-owns": "result-list-".concat(_vm.id),
      "aria-expanded": _vm.isFocused && _vm.data.length > 0 ? 'true' : 'false'
    }
  }, [_c('div', {
    class: _vm.inputGroupClasses
  }, [_vm.$slots.prepend || _vm.prepend ? _c('div', {
    ref: "prependDiv",
    staticClass: "input-group-prepend"
  }, [_vm._t("prepend", function () {
    return [_c('span', {
      staticClass: "input-group-text"
    }, [_vm._v(_vm._s(_vm.prepend))])];
  })], 2) : _vm._e(), _c('input', {
    ref: "input",
    class: "form-control ".concat(_vm.inputClass),
    attrs: {
      "id": "typeahead-input-".concat(_vm.id),
      "type": "text",
      "role": "searchbox",
      "aria-labelledby": _vm.ariaLabelledBy,
      "aria-multiline": "false",
      "aria-autocomplete": "list",
      "aria-controls": "result-list-".concat(_vm.id),
      "aria-activedescendant": "selected-option-".concat(_vm.id),
      "name": _vm.inputName,
      "placeholder": _vm.placeholder,
      "aria-label": !_vm.ariaLabelledBy ? _vm.placeholder : false,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.inputValue
    },
    on: {
      "focus": function focus($event) {
        _vm.isFocused = true;
      },
      "blur": _vm.handleFocusOut,
      "input": function input($event) {
        return _vm.handleInput($event.target.value);
      },
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.handleEsc($event.target.value);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('keydown.enter', $event);
      }],
      "keyup": function keyup($event) {
        return _vm.$emit('keyup', $event);
      }
    }
  }), _vm.$slots.append || _vm.append ? _c('div', {
    staticClass: "input-group-append"
  }, [_vm._t("append", function () {
    return [_c('span', {
      staticClass: "input-group-text"
    }, [_vm._v(_vm._s(_vm.append))])];
  })], 2) : _vm._e()]), _c('vue-typeahead-bootstrap-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isFocused && _vm.data.length > 0,
      expression: "isFocused && data.length > 0"
    }],
    ref: "list",
    staticClass: "vbt-autcomplete-list",
    attrs: {
      "id": "result-list-".concat(_vm.id),
      "query": _vm.inputValue,
      "data": _vm.formattedData,
      "background-variant": _vm.backgroundVariant,
      "background-variant-resolver": _vm.backgroundVariantResolver,
      "text-variant": _vm.textVariant,
      "maxMatches": _vm.maxMatches,
      "minMatchingChars": _vm.minMatchingChars,
      "disableSort": _vm.disableSort,
      "showOnFocus": _vm.showOnFocus,
      "showAllResults": _vm.showAllResults,
      "highlightClass": _vm.highlightClass,
      "disabledValues": _vm.disabledValues,
      "vbtUniqueId": _vm.id,
      "role": "listbox"
    },
    on: {
      "hit": _vm.handleHit,
      "listItemBlur": _vm.handleChildBlur
    },
    scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (slot, slotName) {
      return {
        key: slotName,
        fn: function fn(_ref) {
          var data = _ref.data,
            htmlText = _ref.htmlText;
          return [_vm._t(slotName, null, null, {
            data: data,
            htmlText: htmlText
          })];
        }
      };
    })], null, true)
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }